window.onload = function () {
  //Popup
  var popup = document.querySelector('.popup');
  var over_18 = localStorage.getItem('over_18');
  if (popup && !over_18) {
    popup.classList.add('open');
    document.body.style.overflowY = 'hidden';
  }
  popup.addEventListener('click', function (event) {
    var target = event.target.closest(".exit-website");
    if (target) {
      window.history.go(-1);
    }
  });

  //Sticky header
  setStickyHeader();

  /*window.addEventListener('scroll', function() {
      setStickyHeader ();
  });*/
};

window.addEventListener('scroll', function () {
  setStickyHeader();
});

//Popup functions
function closePopup() {
  var popup = document.querySelector('.popup');
  popup.classList.remove('open');
  localStorage.setItem('over_18', true);
  document.body.style.overflowY = 'auto';
}
function displayRestrictedMessage() {
  var popupSubtitle = document.querySelector('.popup-subtitle');
  var popupText = document.querySelector('.popup-text');
  var popupButtons = document.querySelector('.popup-buttons');
  popupSubtitle.innerText = 'Uh Oh! This website is for the 18+ crowd only.';
  popupText.innerText = "Come back when you're legal and we'll show you a good time!";
  popupButtons.innerHTML = "<a class='button exit-website' href='https://google.com/' >Exit the Website</a>";
}

//Sticky Header functions
function setStickyHeader() {
  var header = document.querySelector('#header');
  var scroll = window.scrollY;
  if (scroll > 0) {
    header.classList.add('sticky');
  } else if (scroll < 10) {
    header.classList.remove('sticky');
  }
}